import styled from 'styled-components';
import { Black, Dark_Gray, White } from '../../colors';
export const Container = styled.div`
    max-width: 1200px;
`;
export const MenuItem = styled.li`
    text-decoration: none;
    color: white;
    list-style: none;
    list-style-type: none;
    text-decoration-line: none;
    margin-top: 3rem;
    a{
        color: ${Dark_Gray};
        font-size: 3.5rem;
        font-family: 'Josefin Sans';
        padding: 2rem;
        padding-top: 6.5rem;
        text-decoration: none;
    }
`;

export const Close = styled.li`
    color: ${White};
    cursor: pointer;
    font-size: 2em;
    font-family: "Alata";
    position: absolute;
    right: 3rem;
    list-style: none;
    top: 2.1rem;
`;

export const MenuContainer = styled.div`
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    background-color: ${Black};
`;

export const Logo = styled.img`
    font-size: 1.5rem;
    padding: 2rem;
    padding-top: 2.5rem;
`;

export const Menu = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (min-width: 1000px){
        display: none;
    }
`;

export const HamburguerMenu = styled.img`
    padding: 2rem;
    padding-top: 2.6rem;
`;

export const SloganBox = styled.div`
    position: absolute;
    margin-top: 162%;
    margin-left: 12%;
    height: 25vh;
    border: 2px solid ${White};
    font-size: 2em;
    width: 70vw;
    h1{
        font-size: 1.3em;
        font-weight: 300;
        width: 40vw;
        font-family: "Josefin Sans";
        color: ${White};
        padding:2rem;
    }

    @media (max-height: 600px){
        margin-top: 102%;
    }
`;



////////////////////////////////////////////////Desktop

export const MenuDesktop = styled.div`
    display: block;
    @media (max-width: 1000px){
        display: none;
    }
    @media (max-width: 2560px){
        margin: 0 auto;
        width:100vw;
    }
`;

export const MenuOtherDes = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
   
`;

export const LogoDesktop = styled.img`
    font-size: 1.5rem;
    padding: 2rem;
    padding-top: 2.5rem;
`;

export const MenuItemDesktop = styled.li`
    list-style-type: none;
    font-family: "Alata";
    
    a{
        color: ${White};
        text-decoration: none;
        justify-content: flex-end;
        margin-right: 1.5em;
    }

`;

export const ItensDesk = styled.div`
    display: flex;
    position: relative;
    @media (max-width: 2560px){
        justify-content: end ;
        right: 0;
    }
`;

export const SloganDeskBox = styled.div`
    display: flex;
    align-items: center;
    text-align: left;
    width: 40vw;
    position: relative;
    left: calc(100vw - 88%);
    margin-top: 5%;
    border: 2px solid ${White};

    h1{
        font-size: 2.5em;
        font-weight: 300;
        width: 40vw;
        font-family: "Josefin Sans";
        color: ${White};
        padding:2rem;
    }

    @media (max-width: 2560px){
        left: calc(100vw - 82%);
        margin-top: 10%;
        h1{
            font-size: calc(100vw - 95vw);
        }
    }

    @media (max-width: 1800px){
        h1{
            font-size: 2.5rem;
        }
    }

    @media (max-height: 600px){
        margin-top: 5%;
    }
`;